import { render } from "./AuditLogBrowser.vue?vue&type=template&id=0df169ef"
import script from "./AuditLogBrowser.vue?vue&type=script&lang=js"
export * from "./AuditLogBrowser.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__